import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SANITARYCLASSIFICATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SanitaryClassification.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SanitaryClassification.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SANITARYCLASSIFICATION_CONFIG = {
  entityName: 'SanitaryClassification',
  localizationKey: 'Planning::Entity.SanitaryClassification',
  fields: SANITARYCLASSIFICATION_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.SanitaryClassifications',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
